module.exports = __webpack_public_path__ + "img/BF4.650b6fc4.svg";